<div
  novaCard
  variant="primary"
  class="rcm-summary__card"
  [ngClass]="'rcm-summary__card--' + card.accent"
  *ngFor="let card of cards; trackBy: trackByKey"
>
  <div novaCardContent>
    <div class="rcm-summary__top">
      <nova-icon
        class="rcm-summary__icon"
        [name]="card.iconName"
        [size]="20"
      ></nova-icon>
      <div
        novaSkeleton
        variant="text"
        [hasAnimation]="true"
        class="rcm-summary__skeleton rcm-summary__skeleton--count"
        aria-hidden="true"
        *ngIf="loading; else count"
      ></div>
      <ng-template #count>
        <span
          class="rcm-summary__count"
          [attr.data-testid]="card.key + '-count'"
        >
          {{ card.value }}
        </span>
      </ng-template>
    </div>
    <h2 class="rcm-summary__label">{{ card.label }}</h2>
    <div
      novaSkeleton
      variant="text"
      [hasAnimation]="true"
      class="rcm-summary__skeleton rcm-summary__skeleton--sublabel"
      aria-hidden="true"
      *ngIf="loading; else sublabel"
    ></div>
    <ng-template #sublabel>
      <p class="rcm-summary__sublabel">{{ card.sublabel }}</p>
    </ng-template>
  </div>
</div>
